<template>
  <div class="profiles_container loader-container">
    <svg
      :style="'transform: scale(' + scale + ');'"
      width="200px"
      height="200px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      class="lds-rolling"
      style="background: none;"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        :ng-attr-stroke="color"
        ng-attr-stroke-width="2"
        ng-attr-r="10"
        :stroke="color"
        stroke-width="2"
        r="10"
        stroke-dasharray="47.12388980384689 17.707963267948966"
        transform="rotate(54.4137 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1.1s"
          begin="0s"
          repeatCount="indefinite"
        ></animateTransform>
      </circle>
    </svg>
  </div>
</template>

<script>
export default {
  props: ["color", "scale"],
}
</script>

<style lang="scss" scoped>
svg {
  width: 100px;
  height: 100px;
  display: inline-block;
  transition: none;
  * {
    transition: none;
  }
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
